import api from 'api';

export const uploadFile = async (data) => api().post('/s3', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
